var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41820_9182)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_41820_9182",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_41820_9182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 18.25C15.75 18.5625 15.375 18.75 15 18.75H6.875V17.5H15L14.3125 15H7.9375C7.375 15 6.875 14.625 6.75 14.0625L3.125 1.25H3.4375H3.5H5.625C6.4375 1.25 7.1875 1.8125 7.4375 2.625L9.8125 11.25H15V12.5H8.875L6.1875 2.9375C6.125 2.6875 5.875 2.5 5.625 2.5H4.75L7.9375 13.75H15.1875L16.1875 17.1875C16.3125 17.5625 16.25 17.9375 16 18.25Z",
    fill: "#BFA247"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41820_9182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSeat);
export default __webpack_public_path__ + "static/media/icon-seat.8c46690d7cc86ea02c2caeda2d62ea9b.svg";
export { ForwardRef as ReactComponent };